import React, {useEffect,useState} from 'react'
import { Helmet } from 'react-helmet'
import ProductPost from '../components/ProductPost';
import Magazine from '../components/Magazine';
import { useAuth } from '../Context/AuthContext';
import Preloader from '../components/Preloader';
const Utility=require('../Utility/Utilty');


export default function Home({}){
    const {authUser, isLoggedIn, countItems, UpdateBagCount ,setAuthUser ,setIsLoggedIn } =useAuth();
    const [newProducts, setProducts] = useState([]);
    const [UID, setUserID] = useState('');


    useEffect(() => {
        // Fetch newProducts when the component mounts
    console.log("HomeUID-i:",authUser.ID);
    // setUserID(userID);

        fetch('/listProducts?filter=NewItem%3D1')
            .then(response => response.json())
            .then(data => setProducts(data))  
            .catch(error => console.error('Error fetching newProducts:', error));
    }, [authUser]); // Empty dependency array ensures the effect runs only once
    
    // useEffect(() => {       
    //     // setUserID(userID);
    //     console.log("HomeUID-f:",authUser.ID);    
    // }, [userID]);

    useEffect(() => {
        // Dynamically create a script element
        const script = document.createElement('script');
        script.src = 'assets/scripts/home-script.js';
        script.async = true;
    
        // Append the script to the document body
        document.body.appendChild(script);      
      

        // Cleanup: Remove the script when the component unmounts
        return () => {
          document.body.removeChild(script);
        };
      }, []);

  
      const util= new Utility();

   
    return (     

             
        <div>
        <Helmet>
            <title>Home</title>
        </Helmet>

        {/* <Header UserId={UID} /> */}

        <Preloader />
        <section id="masthead">        
        <div id="mstd-1" className="col-6" >
            
            <div id="container" style={{marginTop: '12vh'}}>              
                <div className="msg-box">
                    <p  id="message" className="msg-l"></p>
                </div>            
            </div>

            <div id="container" style={{marginTop: '12vh'}}>              
                <div className="msg-box">
                    <p  id="message0" className="msg-r"></p>
                </div>            
            </div>

            <div id="container" style={{marginTop: '12vh'}}>              
                <div className="msg-box">
                    <p  id="message3" className="msg-l"></p>
                </div>            
            </div>

            <div id="container" style={{marginTop: '12vh'}}>              
                <div className="msg-box">
                    <p  id="message5" className="msg-r"></p>
                </div>            
            </div>

            

        </div>
        <div id="mstd-2" className="col-6" style={{marginLeft:'-1px'}} >

            <div id="container" style={{marginTop: '12vh'}}>              
                <div className="msg-box">
                    <p  id="message1" className="msg-r"></p>
                </div>            
            </div>

            <div id="container" style={{marginTop: '12vh'}}>              
                <div className="msg-box">
                    <p  id="message2" className="msg-l"></p>
                </div>            
            </div>

            <div id="container" style={{marginTop: '12vh'}}>              
                <div className="msg-box">
                    <p  id="message4" className="msg-r"></p>
                </div>            
            </div>

            <div id="container" style={{marginTop: '12vh'}}>              
                <div className="msg-box">
                    <p  id="message6" className="msg-l"></p>
                </div>            
            </div>
        
        </div>
    </section>

            <div className="wc-100">
                <hr className="w-50" />       
            </div>

            {/* <section  className="mstd-banner" style={{background: 'url(assets/imgs/1080pxframe.jpg)', 
                                                        backgroundPosition: 'center',
                                                        backgroundRepeat: 'no-repeat',
                                                        backgroundSize: 'cover'}} >
                <h4 style={{textTransform: 'uppercase', textShadow: '1px 1px 1px rgb(99, 98, 98)' ,color: 'rgb(199 197 197)' }}>
                    Shop Online Now
                </h4>        
            </section>


           

                    {( typeof newProducts === 'undefined'|| newProducts.length===0 ) ? (
                        <div></div>
                    ) : (
                        
                    <section id="Shop-New" style={{display: 'flex',  justifyContent: 'center', padding: '1vh', flexWrap: 'wrap', marginBottom: '3rem'}}  >
                    
                        <div className="text-center w-100">
                                <hr className="w-50" />
                            <h4 id="ShopNewCapt"  >NEW</h4>
                        </div>
                        
                        
                        <div id="shop-new-post" className="d-flex mx-auto ovf-x">

                             
                        { newProducts.map((product) => (                                           

                            <ProductPost
                                key={product.ID}
                                productID={product.ID}
                                description={product.Description}
                                priceVal={product.Price}
                                discount={product.Discount}
                                sizesAvail="[L][M][S]"
                                imgSrc={ util.getImageUrl(product.ImageType0,product.Image0)}
                                UserID={authUser.ID}
                                                            
                            />))
                            }
                            
                        </div>
                    </section>

                    )}  
                       
          
            <section id="Magazine" style={{ display: 'flex', justifyContent: 'center', padding: '1vh', flexWrap: 'wrap', backgroundColor: 'rgb(245, 245, 245, 0.40)' }}>
            <div style={{ width: '100%', textAlign: 'center' }}>
                <hr style={{ width: '35%', border: '1px solid rgba(192, 192, 192, 0.20)', marginTop: '6.5vh', marginBottom: '7.5vh' }} />
                <h4>MAGAZINE - lOok BOOK</h4>
                </div>
                <Magazine />

            </section> */}

            <script src="assets/scripts/main-script.js"></script>
            <script src="assets/scripts/home-script.js"></script>
        </div>
       
       
    );



        


}